export const isNumber = n => !isNaN(parseFloat(n)) && isFinite(n);
export const isValidButton = b => b === 0;



// WEBPACK FOOTER //
// ./src/util/validate.js